<template>
  <lay-out>
    <Row class="mem-tabs" type="flex" >
      <div
        v-for="(item,index) in tabList"
        :key="index"
        class="tab-item cursor"
        :class="filter.status === item.value ? ['active'] : ''"
        @click="activeChange(item.value)"
      >
        <span >{{item.key}}</span>
      </div>
    </Row>
    <div class="my-coupon-container c-f">
      <div class="coupon-list">
        <Row type="flex" :gutter="20">
          <Col :span="8" v-for="item in list" :key="item.id">
            <coupon-item :data="item"></coupon-item>
          </Col>
        </Row>
        <div class="empty-pic align-center" v-if="!list || list.length == 0">
          <img src="@/assets/coupon-empty.png" alt="" width="150px" >
          <p class=" f-24 m-t-20" style="color: rgb(160, 160, 160);">您还没有优惠券哦</p>
        </div>
      </div>
      <div class="instruction">
        <div class="title">优惠券使用说明</div>
        <div class="content">
          <p>1）什么是优惠券</p>
          <p>优惠券（红包）是住逻辑回馈广大用户推出的电子优惠券，包含：折扣券、满减券等，仅支持在住逻辑系统内使用。</p>
          <p>2）优惠券使用途径</p>
          <p>优惠券可以通过参加各种住逻辑线上活动获得，并在住逻辑系统内下单使用。</p>
          <p>3）优惠券使用规则</p>
          <p>1.订单满足优惠券使用条件则可选择对应类型的优惠券使用。 2.不同的优惠券本身在使用时有一定限制，在优惠券页面有相应的提示。 3.具体的优惠券力度和使用条件以该优惠券的使用说明为准，敬请留意。 4.如在订单付款前取消订单，优惠券会自动退回到个人账户。 5.您已使用优惠券并付款的订单交易关闭按交易失败处理，优惠券不予退还。 6.优惠券过期作废，不支持延期。</p>
          <p class="align-right"><a :href="`${VUE_APP_OLD_BASIC_URL}/help/questionDetail/promotioncode`" target="_blank">查看优惠券详细说明</a></p>
        </div>
      </div>
    </div>
  </lay-out>
</template>

<script>
import axios from 'axios'
import LayOut from "./layout";
import CouponItem from '@/components/coupon-item-new.vue'

export default {
  data(){
    return {
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL,
      list:[],
      tabList:[{key:'未使用的优惠券',value:0},{key:'已使用的优惠券',value:1},{key:'已过期的优惠券',value:2}],
      filter:{
        pageNum:1,
        pageSize:18,
        status:0,
        type:1
      },
      total:0
    }
  },
  components:{
    LayOut,
    CouponItem
  },
  methods:{
    activeChange(val){
      this.filter.status = val
      this.getList()
    },
    handleClick(){
      console.log('选择未使用的优惠券')
    },
    getList(){
      axios.get('/designer_api/promotion_code',{params:this.filter}).then(res=> {
        this.list = res.list
        this.total = res.total
      })
    }
  },
  created(){
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.my-coupon-container{
  padding:30px; 
  .coupon-list{
    padding:0 85px 100px;
    .coupon-item{
      height:180px;
      background:#FFEDED;
      border-radius: 4px;
      padding:15px 30px;
      color:#313131;
      position: relative;
      .title{
        margin-bottom:8px;
      }
      p{
        margin-bottom:6px;
      }
      .c-tips{
        color:#707070;
        line-height: 14px;
      }
      .icon-wancheng-copy{
        font-size: 20px;
        color:#E56A69;
        position: absolute;
        top:12px;
        right:12px;
      }
      .used-pin{
        width:62px;
        height:62px;
        border-radius: 32px;
        border:solid 1px #E56A69;
        background-color: #fff;
        position: absolute;
        right:10px;
        bottom:10px;
        font-size:14px;
        color: #E56A69;
        line-height: 60px;
        text-align: center;
        transform: rotate(-25deg);
      }
      &.disabled{
        background:#D2D2D2;
        p{
          color:#707070;
          span{
            color:#707070;
          }
        }
      }
    }
    .empty-pic{
      padding-top:50px;
    }
  }
  .instruction{
    color:#313131;
    .title{
      font-size: 18px;
      margin-bottom: 18px;
    }
    .content{
      font-size:14px;
      font-weight:500;
      line-height:24px;
    }
  }
}
</style>
